import { Component, Input, OnInit } from '@angular/core';
import { PopoverController } from "@ionic/angular";
import { ActivityLogService } from 'src/app/shared-lib/domains/activity-log';
import { ShippingInternalStatus } from 'src/app/shared-lib/domains/order';
import { OrderPaymentStatus } from 'src/app/shared-lib/domains/payment';
import { ShippingLabelService } from 'src/app/shared-lib/domains/shipping-label';
import { WalletService } from "src/app/shared-lib/domains/wallet";
import { PostalAddress } from 'src/app/shared-lib/global/models';
import { OrderProcessStatus } from '../../shared-lib/domains/order';

@Component({
  selector: 'app-actions-menu',
  templateUrl: './actions-menu.component.html',
  styleUrls: ['./actions-menu.component.scss'],
  standalone: false
})
export class ActionsMenuComponent implements OnInit {

  @Input() isDraft: boolean;
  @Input() order;
  @Input() address: PostalAddress;
  @Input() textContent: any;

  paymentStatus: typeof OrderPaymentStatus = OrderPaymentStatus;
  internalTrackingStatus: ShippingInternalStatus;
  showReportIncident: boolean = false;

  constructor(
    private popoverCtrl: PopoverController,
    private walletService: WalletService,
    private shippingLabelService: ShippingLabelService,
    private activityLogService: ActivityLogService
  ) {
  }

  async ngOnInit() {

    const shippingLabel = await this.shippingLabelService.getShippingLabelByOrderId(this.order.id);
    this.internalTrackingStatus = shippingLabel?.tracking?.internalStatus ?? null;

    this.showReportIncident = await this.getShowReportIncident();
  }

  public emitAction(type: string, value?: any): void {
    this.popoverCtrl.dismiss({ type: type, value: value });
  }

  get isPaid() {
    return this.order.paymentStatus == OrderPaymentStatus.PAID;
  }

  get isRefunded() {
    return this.order.paymentStatus == OrderPaymentStatus.REFUNDED;
  }

  get isProcessPending() {
    return this.order.processStatus == OrderProcessStatus.PENDING;
  }

  get isProcessShipped() {
    return this.order.processStatus == OrderProcessStatus.SHIPPED;
  }

  get alloworderDataModification() {
    return [OrderProcessStatus.PENDING, OrderProcessStatus.PROCESSING].includes(this.order.processStatus);
  }

  get hasReportIncident() {
    return this.order?.hasReportIncident === true;
  }

  get pendingRestartedOrderExists() {
    return this.walletService.wallet.accumulatedDiscount > 0 || this.walletService.wallet.forcedToUse;
  }

  get hasSomeRefund() {
    return this.order?.refundedAmt && this.order?.refundedAmt > 0;
  }

  async getShowReportIncident(): Promise<boolean> {
    let show = false;
    const currentDate = new Date();

    // Las condiciones para que se muestre el botón de notificar incidencia son diferentes si el envío es local o no.
    // Si es local (o si no tiene estado de trazabilidad interna), se mostrará solo cuando el estado de procesamiento sea "enviado"
    // y hayan transcurrido más de 2 días desde que se envió.
    // Si no es local, se mostrará cuando se haya entregado.
    if (this.order.shippingCourierService === 'local' || this.internalTrackingStatus === undefined) {

      // Obtenemos la fecha en la que el pedido pasó a shipped (enviado)
      if (this.order.processStatus === OrderProcessStatus.SHIPPED) {
        const shippedDate = await this.activityLogService.getLastShippedDate(this.order.id);
        if (shippedDate) {
          show = currentDate.getTime() - shippedDate.getTime() > 2 * 24 * 60 * 60 * 1000;
        }
      }
    } else {
      show = this.isPaid && this.internalTrackingStatus === ShippingInternalStatus.DELIVERED;
    }
    return show;
  }

}

